<div class="modal-header">
  <h5 class="modal-title">
    Firmar con CLM Sign
    @if (documentName) {
      <small class="text-muted d-block">{{ documentName }}</small>
    }
  </h5>
  <button type="button" class="close" aria-label="Close" (click)="close(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body p-0">
  @if (!signingUrl) {
    <div class="p-4 text-center text-muted">
      El enlace de firma aún no está disponible. Recargue el detalle en unos segundos
      o revise la configuración de CLM Sign.
    </div>
  } @else {
    @if (recipientName) {
      <div class="px-3 py-2 border-bottom small text-muted">
        Firmante: <strong>{{ recipientName }}</strong>
      </div>
    }
    <div class="lexgo-iframe-wrap">
      <iframe
        class="lexgo-iframe"
        [src]="safeUrl"
        title="CLM Sign"
        allow="clipboard-write"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
    @if (iframeBlockedHint) {
      <div class="px-3 py-2 small text-muted border-top">
        Si la vista queda en blanco, el proveedor puede bloquear iframes.
        Use <strong>Abrir en pestaña</strong>.
      </div>
    }
  }
</div>

<div class="modal-footer">
  @if (signingUrl) {
    <button type="button" class="btn btn-outline-secondary" (click)="openExternal()">
      <i class="fas fa-external-link-alt mr-1"></i>
      Abrir en pestaña
    </button>
  }
  <button type="button" class="btn btn-primary" (click)="close(true)">
    Listo / cerrar
  </button>
</div>
